<template>
  <el-table :data="records" border empty-text="暂无记录" style="width: 100%">
    <el-table-column prop="id" label="ID" width="70" align="center" />
    <el-table-column label="科目" width="80" align="center">
      <template slot-scope="scope">{{ scope.row.subject === 1 ? '科一' : '科四' }}</template>
    </el-table-column>
    <el-table-column prop="recnum" label="学习次数" width="100" align="center" />
    <el-table-column label="时长" width="90" align="center">
      <template slot-scope="scope">{{ formatHours(scope.row.durationSeconds) }}h</template>
    </el-table-column>
    <el-table-column prop="startTime" label="开始时间" min-width="155" />
    <el-table-column prop="endTime" label="结束时间" min-width="155" />
    <el-table-column label="状态" width="110" align="center">
      <template slot-scope="scope">
        <el-tag size="mini" :type="reportStatusType(scope.row.status)">{{ reportStatusLabel(scope.row.status) }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="statusMessage" label="状态说明" min-width="160" show-overflow-tooltip />
    <el-table-column label="照片" width="210" align="center">
      <template slot-scope="scope">
        <div v-if="recordPhotos(scope.row).length" class="record-photos">
          <el-image v-for="photo in recordPhotos(scope.row)" :key="photo.label + photo.url"
                    :src="photo.url" :preview-src-list="recordPhotoUrls(scope.row)"
                    fit="cover" class="record-photo" :alt="photo.label">
            <div slot="error" class="photo-error">—</div>
          </el-image>
        </div>
        <span v-else>—</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { formatHours, reportStatusLabel, reportStatusType } from '@/utils/motorcycleLearning'

export default {
  name: 'MotorcycleLearningRecordTable',
  props: {
    records: { type: Array, default: () => [] }
  },
  methods: {
    formatHours,
    reportStatusLabel,
    reportStatusType,
    recordPhotos (record) {
      const processPhotos = String(record.processPhotoUrls || '').split(';').filter(Boolean)
      return [
        { label: '底照', url: record.portraitUrl },
        { label: '签到', url: record.signPhotoUrl },
        ...processPhotos.map((url, index) => ({ label: `过程${index + 1}`, url })),
        { label: '签退', url: record.signOutPhotoUrl }
      ].filter(photo => photo.url)
    },
    recordPhotoUrls (record) {
      return this.recordPhotos(record).map(photo => photo.url)
    }
  }
}
</script>

<style lang="less" scoped>
.record-photos { display: flex; justify-content: center; gap: 5px; flex-wrap: wrap; }
.record-photo { width: 34px; height: 44px; border: 1px solid #dcdfe6; border-radius: 2px; }
.photo-error { display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; color: #909399; background: #f5f7fa; }
</style>
